import { createReducer, on } from '@ngrx/store';
import { AppointmentEntity } from 'src/app/models/appointment.model';
import * as AppointmentActions from './appointment.actions';

export interface AppointmentState {
  upcomingAppointments: AppointmentEntity[];
  isLoading: boolean;
  error: string | null;
}

const initialState: AppointmentState = {
  upcomingAppointments: [],
  isLoading: false,
  error: null,
};

export const appointmentReducer = createReducer(
  initialState,
  on(AppointmentActions.loadUpcomingAppointments, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(AppointmentActions.refreshUpcomingAppointments, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(
    AppointmentActions.loadUpcomingAppointmentsSuccess,
    (state, { appointments }) => ({
      ...state,
      upcomingAppointments: appointments,
      isLoading: false,
      error: null,
    })
  ),
  on(
    AppointmentActions.loadUpcomingAppointmentsFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })
  )
);

